import jwt_decode from 'jwt-decode';

/**
 *
 * @param {{
 *  authorization: {
 *      code: string,
 *      id_token: string
 *  },
 *  skipCreation: boolean
 * }} response
 *
 * @returns {{
 *  email: string,
 *  expirationTimestamp: number,
 *  accessToken: string,
 *  skipCreation: boolean,
 * }}
 */
export const buildAppleLoginResponse = (response = {}) => {
    const {
        // This is undefined most of the times.
        skipCreation,
        authorization: { id_token: idToken, code } = {},
        email: responseEmail,
    } = response;
    let decodedInfo = {};

    try {
        const { email, auth_time } = jwt_decode(idToken);

        decodedInfo = {
            email: responseEmail || email,
            expirationTimestamp: auth_time,
        };
    } catch (error) {
        decodedInfo = { email: responseEmail || '', expirationTimestamp: '0' };
    }

    return {
        skipCreation,
        accessToken: code,
        ...decodedInfo,
    };
};
